export default function selectRoot(state) {
  return state.entity
}
